module.exports = "https://dev.stanwinstonschool.com/kong_skullisland_poster_alt Large.1f743fff0f1f2f02fc49be99d4f49b0e.jpeg";